import React from "react";
import { Box, Button } from "@mui/material";
import { isAndroid, isIOS, isMacOs, isWindows, osName } from "react-device-detect";


const CommonStoreButton = () => {
  const appStoreHandler = () => {
    if (isAndroid || isWindows || osName === "Linux") {
      window.open("https://play.google.com/store/apps/details?id=com.biosynciq");
    } else if (isIOS || isMacOs) {
      window.open("https://apps.apple.com/us/app/biosynciq");
    }
  };

  return (
    <Box padding="20px 0">
      <Button
        variant="contained"
        onClick={appStoreHandler}
        sx={{ textTransform: "capitalize" }}
      >
        Download BiosyncIQ Mobile app
      </Button>
    </Box>
  );
};

export default CommonStoreButton;
